import React, { FC, memo } from 'react';

import { TypesOfRVsProps } from '@/pages/types-of-rvs';

import RichText from '../static-pages/wagtail/RichText/RichText';
import Tag, { TagColors, TagSizes } from '../switchback/Tag/Tag';
import ResponsiveImage from '../utility/ResponsiveImage/ResponsiveImage';
import css from './RoadsideAssistanceTemplate.module.css';

interface ImageProps {
  title: string;
  url: string;
}

interface RVTypesProps {
  title: string;
  tag: string;
  description: string;
  image: ImageProps | null;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getRvTypes = (contentBlocks: { type: string; value: any }[]) =>
  contentBlocks
    .filter(
      block =>
        block.type === 'split' &&
        Array.isArray(block.value?.left) &&
        Array.isArray(block.value?.right),
    )
    .map(rvBlock => {
      return { left: rvBlock.value.left, right: rvBlock.value.right };
    });

export const getFormatedRVTypes = (
  rvTypes: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    left: any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    right: any;
  }[],
): RVTypesProps[] =>
  rvTypes.map(rv => {
    return {
      title: rv.left[0]?.type === 'heading' ? rv.left[0]?.value : '',
      tag: rv.right[0]?.type === 'heading' ? rv.right[0]?.value : '',
      description: rv.left[1]?.type === 'richtext' ? rv.left[1]?.value : '',
      image: rv.right[1]?.type === 'image' ? rv.right[1]?.value : null,
    };
  });

const TypesOfRVsTemplate: FC<TypesOfRVsProps> = ({ heroHeading, contentBlocks }) => {
  const rvTypes = getRvTypes(contentBlocks);

  const formatedRVTypes = getFormatedRVTypes(rvTypes);

  const renderRVTypes = () => {
    return formatedRVTypes.map(({ title, tag, image, description }) => (
      <li key={title} className="max-w-xs">
        <div className="flex items-center">
          <h4 className="mr-4 text-gray-800 h4">{title}</h4>
          <Tag color={TagColors.primary} size={TagSizes.small}>
            {tag}
          </Tag>
        </div>

        {image && (
          <ResponsiveImage
            src={image.url}
            alt={image.title}
            className="relative object-cover w-full my-4"
          />
        )}
        <RichText content={description} containerClassName={css.rvDescription} />
      </li>
    ));
  };
  return (
    <main>
      <h2 className="w-full my-20 text-center text-gray-900 h2">{heroHeading}</h2>
      <ul className="px-4 mx-auto my-20 grid lg:grid-cols-2 xl:grid-cols-3 sm:px-8 lg:px-12 gap-16 max-w-xxl justify-items-center">
        {renderRVTypes()}
      </ul>
    </main>
  );
};

export default memo(TypesOfRVsTemplate);
